<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title class="text-subtitle-2">
        <div>
          <v-icon
            class="mr-2"
            small
          >fal fa-hashtag</v-icon>
          {{ `${report.nr}` }} <br>
          <v-icon
            class="mr-1"
            small
          >fal fa-store-alt</v-icon>
          {{ _.get(report, 'cashRegister.store.name') }}
          <v-icon
            class="ml-2 mr-1"
            small
          >fal fa-cash-register</v-icon>
          {{ _.get(report, 'cashRegister.description') }}
        </div>
        <v-spacer />
        <div class="text-right">
          <div class="mb-1">
            <v-icon
              class="mr-1"
              small
            >fal fa-door-open</v-icon>
            {{ $t('Opened') }}: {{ report.created | moment("D MMMM YYYY H:mm") }}
          </div>
          <div>
            <v-icon
              class="mr-1"
              small
            >fal fa-door-closed</v-icon>
            {{ $t('Closed') }}: {{ report.closed | moment("D MMMM YYYY H:mm") }}
          </div>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <h3 class="text-h6 mb-3">{{ $t('Cash Movements') }}</h3>
        <v-simple-table class="table-vs">
          <thead>
            <tr>
              <th class="text-left">{{ $t('Time') }}</th>
              <th class="text-left">{{ $t('Employee') }} </th>
              <th class="text-left">{{ $t('Note') }}</th>
              <th class="text-left">{{ $t('Amount') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in report.cashMovements"
              :key="item.id"
            >
              <td class="pt-2">{{ item.created | moment('D MMMM YYYY HH:mm') }}</td>
              <td class="pt-2">{{ _.get(item, 'creator.screenName') }}</td>
              <td class="pt-2">{{ item.note || '-' }}</td>
              <td
                :class="{ 'red--text': item.amount < 0, 'green--text': item.amount >= 0 }"
                class="pt-2"
              >{{ item.amount | money }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-divider class="mt-6" />

        <h3 class="text-h6 mt-6 mb-3">{{ $t('Payments') }}</h3>
        <v-simple-table class="table-vs">
          <thead>
            <tr>
              <th class="text-left">{{ $t('Payment Method') }}</th>
              <th class="text-left">{{ $t('Expected') }}</th>
              <th class="text-left">{{ $t('Counted') }}</th>
              <th class="text-left">{{ $t('Difference') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in report.cashRegisterPaymentCounts"
              :key="item.id"
            >
              <td class="pt-2">{{ _.get(item, 'paymentMethod.name') }}</td>
              <td class="pt-2">{{ item.expected | money }}</td>
              <td class="pt-2">{{ item.counted | money }}</td>
              <td
                :class="{ 'red--text': item.difference < 0, 'green--text': item.difference >= 0 }"
                class="pt-2"
              >{{ item.difference | money }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="font-weight-bold"> {{ $t('Totals') }} </td>
              <td
                v-if="report.cashRegisterPaymentCounts"
                class="font-weight-bold"
              >{{ report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.expected, 0) | money }}</td>
              <td
                v-if="report.cashRegisterPaymentCounts"
                class="font-weight-bold"
              >{{ report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.counted, 0) | money }}</td>
              <td
                v-if="report.cashRegisterPaymentCounts"
                class="font-weight-bold"
              >{{ report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.difference, 0) | money }}</td>
            </tr>
          </tfoot>
        </v-simple-table>

        <template v-if="report.closedNote">
          <v-divider />
          <h3 class="text-h6 mt-6 mb-2">{{ $t('Note') }}</h3>
          <span>{{ report.closedNote }}</span>
        </template>
      </v-card-text>
      <v-divider v-if="showPrintButton" />
      <v-card-actions v-if="showPrintButton">
        <v-spacer />
        <cash-register-report-printer
          v-if="showPrintButton"
          :report-object="report"
        >
          <template v-slot:activator>
            <v-btn
              class="ml-0"
              color="primary"
              depressed
              text
            >
              <v-icon
                dark
                left
              >print</v-icon>
              {{ $t('Print') }}
            </v-btn>
          </template>
        </cash-register-report-printer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CashRegisterReportPrinter from '@/components/cash-register-reports/CashRegisterReportPrinter'

export default {
  name: 'CashRegisterReportInfo',

  components: {
    CashRegisterReportPrinter
  },

  props: {
    reportObject: {
      default: null,
      type: Object
    },
    showPrintButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data () {
    return {
      report: null
    }
  },

  watch: {
    reportObject: {
      immediate: true,
      handler (reportObject) {
        this.report = Object.assign({}, reportObject)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cash-register-reports/CashRegisterReportInfo.vue